import type { SVGProps } from "react";

export type IconName =
  | "layout-dashboard"
  | "clock"
  | "clock-alert"
  | "message-circle"
  | "users"
  | "clipboard-list"
  | "shopping-bag"
  | "cake-slice"
  | "factory"
  | "truck"
  | "indian-rupee"
  | "wallet"
  | "megaphone"
  | "sparkles"
  | "brain"
  | "settings"
  | "shield-check"
  | "search"
  | "bell"
  | "triangle-alert"
  | "route"
  | "calendar-check"
  | "chef-hat"
  | "plus"
  | "log-out"
  | "user"
  | "help-circle"
  | "chevron-left"
  | "chevron-right"
  | "x"
  | "check"
  | "map-pin"
  | "phone"
  | "mail"
  | "gauge";

const paths: Record<IconName, JSX.Element> = {
  "layout-dashboard": <><rect x="3" y="3" width="7" height="8" rx="2" /><rect x="14" y="3" width="7" height="5" rx="2" /><rect x="14" y="12" width="7" height="9" rx="2" /><rect x="3" y="15" width="7" height="6" rx="2" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  "clock-alert": <><circle cx="12" cy="12" r="9" /><path d="M12 7v5" /><path d="M12 16h.01" /></>,
  "message-circle": <><path d="M21 11.5a8.5 8.5 0 0 1-12.8 7.3L3 20l1.3-5A8.5 8.5 0 1 1 21 11.5Z" /></>,
  users: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
  "clipboard-list": <><rect x="8" y="2" width="8" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12h6" /><path d="M9 16h6" /><path d="M8 8h.01" /></>,
  "shopping-bag": <><path d="M6 8h12l-1 13H7L6 8Z" /><path d="M9 8a3 3 0 0 1 6 0" /></>,
  "cake-slice": <><path d="M4 20h16" /><path d="M4 16h16" /><path d="M5 16 12 4l7 12" /><path d="M12 4v12" /><path d="M8 11h8" /></>,
  factory: <><path d="M3 21h18" /><path d="M5 21V9l5 3V9l5 3V7h4v14" /><path d="M9 17h.01" /><path d="M13 17h.01" /><path d="M17 17h.01" /></>,
  truck: <><path d="M10 17H6a2 2 0 0 1-2-2V6h10v11" /><path d="M14 9h4l3 4v4h-3" /><circle cx="7" cy="17" r="2" /><circle cx="16" cy="17" r="2" /></>,
  "indian-rupee": <><path d="M6 3h12" /><path d="M6 8h12" /><path d="M6 13h5a5 5 0 0 0 0-10" /><path d="m6 13 8 8" /></>,
  wallet: <><path d="M3 7a2 2 0 0 1 2-2h14v14H5a2 2 0 0 1-2-2V7Z" /><path d="M17 12h4v4h-4a2 2 0 0 1 0-4Z" /></>,
  megaphone: <><path d="m3 11 18-5v12L3 13v-2Z" /><path d="M6 13v5a2 2 0 0 0 2 2h1" /></>,
  sparkles: <><path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" /><path d="m5 3 .7 2.3L8 6l-2.3.7L5 9l-.7-2.3L2 6l2.3-.7L5 3Z" /><path d="m19 15 .7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z" /></>,
  brain: <><path d="M9 3a3 3 0 0 0-3 3v1a4 4 0 0 0 0 8v1a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z" /><path d="M15 3a3 3 0 0 1 3 3v1a4 4 0 0 1 0 8v1a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Z" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2 3.4-.2-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V22h-4v-.5a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.2.1-2-3.4.1-.1A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.5-1H3v-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9L4.2 7l2-3.4.2.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5V2h4v.5a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.2-.1 2 3.4-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.5v4h-.5a1.7 1.7 0 0 0-1.5 1Z" /></>,
  "shield-check": <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /><path d="m9 12 2 2 4-5" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>,
  bell: <><path d="M18 8a6 6 0 1 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" /></>,
  "triangle-alert": <><path d="M12 3 2 21h20L12 3Z" /><path d="M12 9v5" /><path d="M12 17h.01" /></>,
  route: <><circle cx="6" cy="19" r="3" /><circle cx="18" cy="5" r="3" /><path d="M9 19h3a4 4 0 0 0 0-8H9a4 4 0 0 1 0-8h6" /></>,
  "calendar-check": <><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h18" /><path d="m8 16 2 2 5-5" /></>,
  "chef-hat": <><path d="M6 13.9a4 4 0 0 1 1-7.8 5 5 0 0 1 10 0 4 4 0 0 1 1 7.8V21H6v-7.1Z" /><path d="M6 17h12" /></>,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  "log-out": <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></>,
  user: <><circle cx="12" cy="7" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  "help-circle": <><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 0 1 4.6 1.4c0 1.8-2.1 2.1-2.1 3.6" /><path d="M12 17h.01" /></>,
  "chevron-left": <path d="m15 18-6-6 6-6" />,
  "chevron-right": <path d="m9 18 6-6-6-6" />,
  x: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
  check: <path d="m5 12 5 5L20 7" />,
  "map-pin": <><path d="M12 21s7-4.4 7-11a7 7 0 1 0-14 0c0 6.6 7 11 7 11Z" /><circle cx="12" cy="10" r="2.5" /></>,
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" />,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
  gauge: <><path d="M12 14v-4" /><path d="M4.9 19a9 9 0 1 1 14.2 0" /><path d="M7 15h.01" /><path d="M17 15h.01" /></>,
};

export function Icon({ name, size = 18, strokeWidth = 2, ...props }: SVGProps<SVGSVGElement> & { name: IconName; size?: number; strokeWidth?: number }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
